import { gql } from '@apollo/client';
import { ProductInfoPublic } from '../fragments';

export default gql`
  query products {
    products {
      ...ProductInfoPublic
    }
  }
  ${ProductInfoPublic}
`;
